import { Box, Button, Dialog, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DialogBoxContent } from 'shared/ui/DialogBoxContent/DialogBoxContent';

interface ItemAvailabilityModalProps {
    open: boolean;
    onClose: () => void;
}

export const ItemAvailabilityModal = ({
    open,
    onClose,
}: ItemAvailabilityModalProps) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogBoxContent
                onClose={onClose}
                buttons={
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            width: '100%',
                            gap: '10px',
                        }}
                    >
                        <Button variant="contained" onClick={onClose}>
                            {t('Close')}
                        </Button>
                    </Box>
                }
            >
                <Box sx={{ maxWidth: '440px' }}>
                    <Typography
                        typography="poppins.subtitle1"
                        sx={{ fontWeight: 700, marginBottom: '24px' }}
                    >
                        {t('Account Setup Needed')}
                    </Typography>
                    <Typography
                        typography="openSans.body2"
                        sx={{ marginBottom: '16px' }}
                    >
                        {t(
                            // eslint-disable-next-line max-len
                            'To add this item to your Property Catalog, you need an active account with one of the suppliers that offers it.',
                        )}
                    </Typography>
                    <Typography
                        typography="openSans.body2"
                        sx={{ marginBottom: '16px' }}
                    >
                        {t('To get started:')}
                    </Typography>
                    <Box
                        component="ol"
                        sx={{ paddingLeft: '20px', marginBottom: '16px' }}
                    >
                        <Typography
                            component="li"
                            typography="openSans.body2"
                            sx={{ marginBottom: '4px' }}
                        >
                            {t('Add the supplier to your Vendors list')}
                        </Typography>
                        <Typography
                            component="li"
                            typography="openSans.body2"
                            sx={{ marginBottom: 0 }}
                        >
                            {t(
                                'Enter the account number provided by the supplier',
                            )}
                        </Typography>
                    </Box>
                    <Typography
                        typography="openSans.body2"
                        sx={{ marginBottom: '24px' }}
                    >
                        {t(
                            "Don't have an account yet? You'll need to contact the supplier to set one up.",
                        )}
                    </Typography>
                </Box>
            </DialogBoxContent>
        </Dialog>
    );
};
